'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getInboxLocation = exports.getCanvasLocation = exports.getGridPosition = undefined;

var _gridUtils = require('../../utils/grid/gridUtils');

var _boardConstants = require('../../../common/boards/boardConstants');

var getGridPosition = exports.getGridPosition = function getGridPosition(domComponent, canvasPositionPx, gridSize) {
    var domComponentRect = domComponent.getBoundingClientRect();
    var scrollLeft = domComponent.scrollLeft,
        scrollTop = domComponent.scrollTop;


    return {
        x: Math.max((0, _gridUtils.pixelsToGridPoints)(canvasPositionPx.x + scrollLeft - domComponentRect.left, gridSize), 0),
        y: Math.max((0, _gridUtils.pixelsToGridPoints)(canvasPositionPx.y + scrollTop - domComponentRect.top, gridSize), 0)
    };
};

var getCanvasLocation = exports.getCanvasLocation = function getCanvasLocation(domComponent, canvasPositionPx, gridSize, parentId) {
    var position = getGridPosition(domComponent, canvasPositionPx, gridSize);
    return {
        location: {
            parentId: parentId,
            section: _boardConstants.BOARD_SECTIONS.CANVAS,
            position: position
        },
        handledBy: domComponent
    };
};

var getInboxLocation = exports.getInboxLocation = function getInboxLocation(parentId) {
    return {
        location: {
            parentId: parentId,
            section: _boardConstants.BOARD_SECTIONS.INBOX,
            position: {
                index: 0
            }
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/canvas/dnd/canvasUtil.js
// module id = 422
// module chunks = 0